import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth1getGetScreenTruthAppsAppBindingsResponseSchema = jsonObject
export type tcpscreentruth1getGetScreenTruthAppsAppBindingsResponse = z.infer<typeof tcpscreentruth1getGetScreenTruthAppsAppBindingsResponseSchema>
